/**
 * Device Blocking Tab Component
 */
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { Checkbox } from "@/components/ui/checkbox";
import { Smartphone } from "lucide-react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DeviceBlockingTab = ({ settings, setSettings }) => {
  
  // Auto-save when any setting changes
  const updateSetting = async (key, value) => {
    const newSettings = { ...settings, [key]: value };
    setSettings(newSettings);
    
    try {
      await axios.put(`${API}/security/settings`, newSettings);
    } catch (error) {
      console.error("Error saving device settings:", error);
      toast.error("Failed to save setting");
      // Revert on error
      setSettings(settings);
    }
  };

  return (
    <Card className="border-amber-200">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 rounded-lg">
              <Smartphone className="w-5 h-5 text-amber-600" />
            </div>
            <div>
              <CardTitle className="text-xl text-amber-800">Device Blocking</CardTitle>
              <CardDescription>Restrict access from specific device types</CardDescription>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <Label className="text-amber-700">Enabled</Label>
            <Switch
              checked={settings.deviceBlockingEnabled}
              onCheckedChange={(checked) => updateSetting('deviceBlockingEnabled', checked)}
            />
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        {settings.deviceBlockingEnabled && (
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center space-x-2 p-3 bg-amber-50 rounded-lg">
              <Checkbox
                id="blockiPhone"
                checked={settings.blockiPhone || false}
                onCheckedChange={(checked) => updateSetting('blockiPhone', checked)}
              />
              <Label htmlFor="blockiPhone" className="text-amber-800">Block iPhone</Label>
            </div>
            <div className="flex items-center space-x-2 p-3 bg-amber-50 rounded-lg">
              <Checkbox
                id="blockiPad"
                checked={settings.blockiPad || false}
                onCheckedChange={(checked) => updateSetting('blockiPad', checked)}
              />
              <Label htmlFor="blockiPad" className="text-amber-800">Block iPad</Label>
            </div>
            <div className="flex items-center space-x-2 p-3 bg-amber-50 rounded-lg">
              <Checkbox
                id="blockAndroid"
                checked={settings.blockAndroid || false}
                onCheckedChange={(checked) => updateSetting('blockAndroid', checked)}
              />
              <Label htmlFor="blockAndroid" className="text-amber-800">Block Android</Label>
            </div>
            <div className="flex items-center space-x-2 p-3 bg-amber-50 rounded-lg">
              <Checkbox
                id="blockDesktop"
                checked={settings.blockDesktop || false}
                onCheckedChange={(checked) => updateSetting('blockDesktop', checked)}
              />
              <Label htmlFor="blockDesktop" className="text-amber-800">Block Desktop</Label>
            </div>
          </div>
        )}
        
        {!settings.deviceBlockingEnabled && (
          <p className="text-gray-500 text-sm">
            Enable device blocking to prevent access from specific device types.
          </p>
        )}
      </CardContent>
    </Card>
  );
};

export default DeviceBlockingTab;
